import {FormControlLabel, Switch} from '@material-ui/core';
import React from 'react';
import {useDispatch} from 'react-redux';
import {changeHasAHLAccess, changeHasNewYorkAccess, changeIsExternalAdmin} from 'Users/ducks/vipUserType';
import {VIPUserType} from 'Users/models/User/Agent/VipUserType';
import './VipUserTypeEntry.sass';

type VIPEntryProps = {
  vipUserType: VIPUserType;
};

const VIPEntry = (props: VIPEntryProps) => {
  const {hasAhlAccess, hasNewYorkAccess, isExternalAdministrator} = props.vipUserType;
  const dispatch = useDispatch();

  return (
    <div className="vip-user-type-section">
      <FormControlLabel
        control={
          <Switch
            checked={hasAhlAccess}
            onChange={e => dispatch(changeHasAHLAccess(e.target.checked))}
            color="primary"
          />
        }
        label="American Heritage Life Access?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={hasNewYorkAccess}
            onChange={e => dispatch(changeHasNewYorkAccess(e.target.checked))}
            color="primary"
          />
        }
        label="New York Access?"
      />
      <FormControlLabel
        control={
          <Switch
            checked={isExternalAdministrator}
            onChange={e => dispatch(changeIsExternalAdmin(e.target.checked))}
            color="primary"
          />
        }
        label="Is External Administrator?"
      />
    </div>
  );
};

export default VIPEntry;
